module.exports = __webpack_public_path__ + "static/logotype-white-fe7e2236ab65a95e40a2f319dbb33c59.png";